import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import CtitemEditFormImpl from './CtitemEditFormImpl';
import CtitemList from './CtitemList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import CtitemListView from './CtitemListView'


export default function CtitemDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.ctitemDashboard);
  const [ ctitemId, setCtitemId] = React.useState('');
  const [reloadCtitemList, setReloadCtitemList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <CtitemEditFormImpl 
            setReloadCtitemList={setReloadCtitemList}
            ctitemId={ctitemId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <CtitemListView 
                      setCtitemId = {setCtitemId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
